import React from 'react';

import { cn } from 'components/lib/utils';
import { Card, CardContent, CardHeader } from 'components/ui/card';

interface IStackedCardProps {
  title: string;
  titleRightContent?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const StackedCard: React.FC<IStackedCardProps> = ({
  title,
  titleRightContent,
  children,
  className
}) => {
  return (
    <Card className={cn("bg-indigo-50 shadow-none border-indigo-50 border-2 w-[592px]", className)}>
      <CardHeader className="flex-row items-center justify-between space-y-0 px-4 py-3">
        <span className="text-p-s font-medium text-base-primary">{title}</span>
        {titleRightContent}
      </CardHeader>
      <CardContent className="p-0">
        <Card className="bg-base-card border-none shadow-none">
          <CardContent className="p-4 m-0 w-full h-full">
            {children}
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  );
};

